<template>
  <section class="appointments">
    <h2 class="appointments__title">Representative Arbitral Appointments</h2>
    <ul class="appointments__list">
      <li><span>Sole arbitrator of a dispute about the election of Chief under a First Nation’s Election Code (award)
      </span></li>
      <li><span>Joint party-appointed arbitrator on a tribunal hearing a dispute between operating and non-operating parties to agreements related to natural gas liquids facilities (settled)
      </span></li>
      <li><span>Sole arbitrator of four related Franchise Agreement disputes in the cannabis industry (awards)
      </span></li>
      <li><span>Chair of a tribunal hearing a dispute over the sale of certain Colombian oil and gas assets under a Purchase and Sale Agreement (award)
      </span></li>             
      <li><span>Sole arbitrator of disputes under the Pest Control Products Act, S.C. 2002, c. 28 regarding compensation for data used in product registration with the Pest Management Regulatory Agency (settled)
      </span></li>
      <li><span>Party appointed arbitrator on a tribunal hearing a dispute under a Producer Agreement in the mining industry regarding audit protocols (award)
      </span></li>
      <li><span>Sole arbitrator of a dispute over fees for the use of a fibre optic network under various Indefeasible Right To Use Agreements (settled)
      </span></li>
      <li><span>Chair of a tribunal hearing a billing dispute under a Co-generation Agreement (settled)
      </span></li>
      <li><span>Sole arbitrator of a dispute regarding the termination of a Cooperation Agreement related to the provision of non-destructive testing services to the energy industry (settled)</span></li>
      <li><span>Sole arbitrator of a dispute in the gaming industry between limited partners over the entitlement to certain funds (award)</span></li>
      <li><span>Sole arbitrator of a dispute under a Share Purchase Agreement regarding earn out provisions and claims of misrepresentation (award)
      </span></li>
      <li><span>Sole arbitrator of a dispute regarding compensation between a junior mining company and its former director and CEO arising from a Consulting Agreement (award)
      </span></li>
      <li><span>Sole arbitrator of a dispute regarding contract management services provided under a CCDC 5B Construction Management Contract 
      </span></li>
      <li><span>Sole arbitrator of shareholders oppression disputes in the taxi industry (award)
      </span></li>
      <li><span>Sole arbitrator of a dispute over certain post-closing adjustments related to the purchase and sale of an intermodal transportation business (award)
      </span></li>
      <li><span>Party appointed arbitrator on a tribunal hearing a dispute concerning the supply of pressure vessels for a major energy infrastructure project</span></li>
      <li><span>Sole arbitrator of a dispute under an Asset Sale Agreement concerning whether certain tax-related adjustments were properly included in a final statement of adjustments (award)</span></li>
      <li><span>Sole arbitrator of a dispute under an IT Service Agreement concerning a cybersecurity incident</span></li>
      <li><span>Sole arbitrator of a dispute concerning a liquidated damages claim under a Rail Transportation Agreement</span></li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'Appointments',
  props: {}
}
</script>

<style lang="scss" scoped>
.appointments {
  padding: 3.75rem 1.5rem 1.5rem 1.5rem;
  display: flex;
  flex-direction: column;
  &__title {
    font-family: 'Avenir', sans-serif;
    text-align: left;
    font-size: 1.75rem;
    font-weight: 800;
    line-height: 36px;
    margin-bottom: 1.5rem;
    &:before {
      top: -22px;
      background: $primary-accent;
      width: 90px;
    }
  }
  &__list {
    li {
      padding: 1.25rem 0.5rem 1.25rem 0;
      text-align: left;
      font-size: 1rem;
      &:first-child {
        padding-top: 0;
      }
    }
  }
}
@media only screen and (min-width: 768px) {
  .appointments {
    padding-top: 5.75rem;
    &__title {
      min-width: 357px;
      max-width: 15ch;
      line-height: 48px;
      font-size: 2.5rem;
      &:before {
      top: -32px;
    }
    }
    &__list {
      li {
        padding: 0.5rem 0 0.5rem 0;
      }
    }
  }
}
@media only screen and (min-width: 1024px) {
  .appointments {
    flex-direction: row;
    padding: 5.625rem 10% 0;
    &__list {
      margin-left: 3.5rem;
    }
  }
}
</style>
